import { useEffect, useMemo } from 'react';

import StateMessage from '@/components/chat/StateMessage';
import { getLocalStorageInstance } from '@/lib/localStorage';
import { AvailableSearchParams, getSearchParam } from '@/lib/params';
import { trpc } from '@/lib/trpc';
import { directEbookSteps, noQualificationSteps, withQualificationSteps } from '@/pages/CreateProduct/steps';
import { authStore } from '@/stores/auth';
import { stepStore } from '@/stores/steps';

const directFlows = {
  ebook: directEbookSteps
} as const;

const Start = () => {
  const enableRequest = () => {
    const session = getLocalStorageInstance()?.getItem('qualifier-onboarding-session-id');
    const eduzzId = authStore.getState().currentUser?.eduzzId;

    if (!eduzzId) {
      return false;
    }

    if (!session) {
      return true;
    }

    const [sessionEduzzId] = session.split(':');
    return Number(sessionEduzzId) !== eduzzId;
  };

  const {
    data: sessionData,
    isLoading,
    error,
    refetch
  } = trpc.qualification.getSession.useQuery(undefined, {
    enabled: enableRequest()
  });

  useEffect(() => {
    const eduzzId = authStore.getState().currentUser?.eduzzId;
    const flow = getSearchParam(AvailableSearchParams.FLOW);

    if (flow && directFlows[flow as keyof typeof directFlows]) {
      stepStore.getState().addSteps({ steps: directFlows[flow as keyof typeof directFlows] });
      stepStore.getState().nextStep();
      return;
    }

    if (!sessionData || !eduzzId) {
      return;
    }

    if (sessionData.isQualified) {
      stepStore.getState().addSteps({ steps: withQualificationSteps });
      stepStore.getState().nextStep();
      return;
    }

    stepStore.getState().addSteps({ steps: noQualificationSteps });
    getLocalStorageInstance()?.setItem('qualifier-onboarding-session-id', `${eduzzId}:${sessionData.sessionId}`);
    stepStore.getState().nextStep();
  }, [sessionData]);

  useEffect(() => {
    const isEnabled = enableRequest();

    if (!isEnabled) {
      stepStore.getState().addSteps({ steps: noQualificationSteps });
      stepStore.getState().nextStep();
    }
  }, []);

  const message = useMemo(() => {
    if (sessionData?.isQualified) {
      return 'Que bom que você está aqui! Vamos começar.';
    }

    return 'Que bom que você está aqui! Gostaríamos de entender melhor sua atuação no mercado digital.';
  }, [sessionData]);

  return (
    <StateMessage
      type='question'
      loading={isLoading && 'Escrevendo...'}
      error={Boolean(error) && 'Não consegui escolher a pergunta correta'}
      onRetry={refetch}
    >
      {message}
    </StateMessage>
  );
};

export default Start;
